<template>
  <div id="quickContact">
    <ul class="quick-container">
      <div id="quick-contact" class="quick-contact" style="margin-bottom: 0px">
        <ul>
          <li class="contact-item" @click="showQrCode">
            <span class="contact-item-icon fa fa-qrcode"></span>
            <span class="contact-item-text">微信咨询</span>
          </li>
          <!-- <li class="contact-item" @click="showOnlineServicer">
            <span class="contact-item-icon el-icon-service"></span>
            <span class="contact-item-text">在线客服</span>
                <div class="online" v-if="onlineDialog">
            </div>
          </li> -->
          <li
            class="contact-item contact-item-flashing"
            @click="message.type == 2 ? showCustomForm() : goToCustomPage()"
          >
            <!-- <img class="contact-item-icon iconfont" src="../../assets/svg/location.svg" alt=""> -->
            <span class="contact-item-icon el-icon-edit"></span>
            <span class="contact-item-text">帮我定制团建</span>
          </li>
        </ul>
      </div>
    </ul>
    <div v-if="needDialog" class="tool-booking">
      <div class="tool-booking-order">
        <div class="element-row" style="height: 54px">
          <div class="element-col" style="height: 54px; padding-right: 55px">
            <span class="txt">出行人数</span>
            <el-select v-model="form.peopleNumber" placeholder="出行人数">
              <el-option
                v-for="(item, index) in getRequirementType.travelNumberType"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div class="element-col" style="height: 54px; padding-left: 5px">
            <span class="txt">人均预算</span>
            <el-select v-model="form.avgPrice" placeholder="人均预算">
              <el-option
                v-for="(item, index) in getRequirementType.avgBudgetType"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div class="element-col" style="height: 54px; padding-right: 70px">
            <span class="txt">团建天数</span>
            <el-select v-model="form.activityDay" placeholder="团建天数">
              <el-option
                v-for="(item, index) in getRequirementType.dayType"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div class="element-col" style="height: 54px; padding-left: 5px">
            <span class="txt">联系人</span>
            <el-input
              v-model="form.contact"
              placeholder="联系人"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div
            class="element-col"
            style="height: 54px; padding-right: 40px; box-sizing: border-box"
          >
            <span class="txt request">联系电话</span>
            <el-input
              v-model="form.mobile"
              placeholder="联系电话"
              style="display: inline"
            ></el-input>
          </div>
          <div
            class="element-col"
            style="height: 54px; padding-left: 29px; padding-right: 8px"
          >
            <span class="txt request">验证码</span>
            <div class="sendCode">
              <el-input
                v-model="form.verificationCode"
                placeholder="4位验证码"
                style="display: inline"
              ></el-input>
              <span
                class="txt2"
                :class="isPhoneNumber(form.mobile) ? 'active-txt2' : ''"
                @click="sendSMS"
                >{{ smsCodeTime != 0 ? smsCodeTime : "短信验证" }}</span
              >
            </div>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div
            class="element-col-simple"
            style="height: 54px; margin-right: 48%"
          >
            <span class="txt">微信号</span>
            <el-input
              v-model="form.wxNumber"
              placeholder="微信号"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div class="element-col" style="height: 54px; margin-left: 5%">
            <span class="txt">备注</span>
            <div class="inner-textarea">
              <el-input
                type="textarea"
                v-model="form.description"
                placeholder="非必填 如有特殊需求请填写备注告诉我们～"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="element-row">
          <div class="element-col element-col-span-8">
            <div
              class="tool-button tool-booking-order-submit tool-button-primary"
            >
              <button @click="submit">提交团建需求</button>
            </div>
          </div>
        </div>
        <div class="element-row">
          <div class="element-col">
            <img src="../../assets/process.png" alt="" />
          </div>
        </div>
        <span class="tool-booking-order-close" @click="closeNeedDialog">×</span>
      </div>
    </div>
    <!-- <el-dialog
      class="qrcode-show"
      title="请微信扫码添加团建策划师，及时沟通更有效"
      :visible.sync="qrCodeDialogVisible"
      :before-close="closeQrCode"
      width="280px"
    >
      <img
        id="qrCode"
        :src="
          basicInfo.customQrCode  
        "
        alt
      />
    </el-dialog> -->
    <div class="qrcode-show-background"  v-if="qrCodeDialogVisible" 
      v-bind:style="{backgroundImage:'url(' +'\''+ basicInfo.customQrCodePic +'\''+ ')', 
      backgroundRepeat:'no-repeat'}">
      <div class="close-button" @click="closeQrCode">X</div>
    </div>
    <!-- <div class="background-contact"  
    v-if="isshowContact"
    v-bind:style="{backgroundImage:'url(' +'\''+ bannerArray.path +'\''+ ')', backgroundRepeat:'no-repeat'}">
      <span>{{bannerArray.title}}</span>
      <p>{{bannerArray.description}}</p>
      <div class="button">
        <div class="inline-contact" @click="showOnlineServicer">在线沟通</div>
      </div>
      <div class="close-button" @click="closeButton">X</div>
    </div> -->

    <!-- <el-dialog  class="aaa" v-if="onlineDialog" width="25%">

      </el-dialog> -->
  </div>
</template>
<script>
import axios from "axios";
import { isPhoneNumber,handlePicPlusPre } from "../../util/util";
// import a from "../../../static/";
export default {
  name: "quickContact",
  data() {
    return {
      scrollTop: 0,
      visible: false,
      visibletime: false,
      onlineDialog: false,
      needDialog: false,
      qrCodeDialogVisible: true,
      smsCodeTime: 0,
      bannerArray: [],
      isshowContact:false,
      // data1:"<div></div>",
      // 提交表单
      form: {
        peopleNumber: "",
        avgPrice: "",
        teamBuildingDay: "",
        contact: "",
        mobile: "",
        verificationCode: "",
        wxNumber: "",
        description: "",
      },
    };
  },
  computed: {
    getRequirementType() {
      return this.$store.state.requirementTypeData;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
  },
  props: ["leftTab", "message"],
  methods: {
    handlePicPlusPre,
    isPhoneNumber,
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let top = document.documentElement.scrollTop; // 实现滚动效果

      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = top -= 200;
        if (top <= 0) {
          clearInterval(timeTop); //清除定时器
        }
      }, 10);
    },
    closeButton(){
      this.isshowContact = false;
    },
    // 获取广告
    getBanner() {
      const params = {
        positionId: 21,
      };
      axios
        .get(`/api/adm/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
           if(res.data &&res.data.code == 200){
            if (res.data.adList) {
              this.bannerArray = res.data.adList;
              if (this.bannerArray && this.bannerArray.length>0) {
                this.bannerArray.forEach((banner) => {
                  if (banner.path) {
                    banner.path = this.handlePicPlusPre(banner.path);
                  } else {
                    banner.path = "ak.jpg";
                  }
                  banner.path = banner.path[0];
                });
                console.log(this.bannerArray)
                this.bannerArray = this.bannerArray[0];
              }else{
                this.bannerArray.path = "ak.jpg";
              }
              console.log(this.bannerArray)
              this.isshowContact = true;
            }
          }
        });
    },
    showOnlineServicer() {
      // this.onlineDialog = true;
      let left = document.documentElement.clientWidth - 540;
      console.log(left)
      window.open('https://103145.kefu.easemob.com/webim/im.html?configId=de986b07-f4cb-4375-9eb8-2a0dd8d9be92', 'newpage','top=200,left='+left+',right=10,width=500,height=640');
      // window.location.href="https://103145.kefu.easemob.com/webim/im.html?configId=de986b07-f4cb-4375-9eb8-2a0dd8d9be92"
    },
    clearForm() {
      // 提交表单
      this.form = {
        peopleNumber: null,
        avgPrice: null,
        activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      };
    },
    // 发送短信
    sendSMS() {
      if (this.smsCodeTime > 0 || !isPhoneNumber(this.form.mobile)) {
        return;
      }
      let params = { mobile: this.form.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 短信计时器
    smsDown() {
      setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
      }, 1000);
    },
    // 提交表单
    submit() {
      let { mobile, verificationCode } = this.form;
      console.log(!mobile || mobile.length != 11);
      console.log(!verificationCode);
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      // this.form = {
      //   mobile,
      //   verificationCode,
      // };
      this.form.type = "1";
      let params = this.form;
      // let params = {
      //   peopleNumber: "",
      //   avgBudget: "",
      //   teamBuildingDay: "",
      //   contact: "",
      //   mobile: "",
      //   verificationCode: "",
      //   wxNo: "",
      //   description: "",
      // };
      axios
        .post(`/api/requirement/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
              if (res.data.msg) {
                msg = res.data.msg;
              } else {
                msg = "需求提交成功";
              }
              this.$message({
                message: msg,
                type: "success",
                center: true,
              });
              this.closeNeedDialog();
            } else {
              if (res.data.code == 500) {
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    showNeed() {
      console.log("sss");
      this.needDialog = true;
    },
     // 打开定制页面
    goToCustomPage(){
      window.open("/#/custom");
    },
    closeNeedDialog() {
      this.clearForm();
      this.needDialog = false;
    },
    closeQrCode() {
      this.qrCodeDialogVisible = false;
    },
    showQrCode() {
      this.qrCodeDialogVisible = true;
    },
    // 展示年会的弹框
    showCustomForm() {
      this.$store.commit("saveAnnualMeetingCustomState", true);
    },
  },
  mounted() {
    // this.getBanner();
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
  scrollToTop() {
    const that = this;
    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    that.scrollTop = scrollTop;
    if (that.scrollTop > 60) {
      that.btnFlag = true;
    } else {
      that.btnFlag = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this tool only -->
<style scoped>
</style>
<style>
#quickContact{
  position: relative;
}
.quick-container .quick-contact {
  position: fixed;
  right: 0;
  bottom: 148px;
  width: 50px;
  z-index: 1900;
}
.quick-container .quick-contact .contact-item {
  color: #fff;
  background: #359ff8dd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.quick-container .quick-contact .contact-item:hover {
  color: #ffe967;
  /* opacity: 1; */
  background: #359ff8;
  -webkit-animation-name: none;
}
.quick-container
  .quick-contact
  .contact-item:hover
  .contact-item.contact-item-flashing {
}
.quick-container .quick-contact .contact-item-icon {
  display: block;
  line-height: 16px;
  width: 20px;
  padding-left: 18px;
  padding-bottom: 5px;
  font-size: 20px;
  font-weight: 700;
}
.quick-container .quick-contact ul li {
  height: 130px;
  line-height: 130px;
  text-align: center;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  position: relative;
}
.quick-container .quick-contact .contact-item-text {
  display: block;
  line-height: 16px;
  width: 20px;
  padding-left: 18px;
  font-size: 14px;
  font-weight: 700;
}
.tool-booking {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 1001;
}
.tool-booking-order {
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  border-radius: 14px;
  width: 616px;
  margin-top: -263px;
  margin-left: -308px;
  padding: 25px 51px;
}

.request::before {
  content: "*";
  color: red;
  position: relative;
}
.element-row,
.element-row:after,
.element-row:before {
  display: flex;
  justify-content: center;
}
.element-row {
  flex-flow: row wrap;
}
.tool-booking .tool-booking-order .tool-booking-order-close {
  display: block;
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 60px;
  text-align: center;
  font-size: 30px;
  cursor: pointer;
  border-radius: 0 14px 0 0;
  transition: all 0.2s ease-in-out;
}
.element-col-span-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}
.element-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.element-col-simple {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: nowrap;
  justify-items: flex-start;
  align-items: center;
}
.element-col-canwrap {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.tool-booking .tool-booking-order .tool-booking-order-submit {
  margin-top: 80px;
}
.tool-button-primary {
  background: #222;
}
.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
.tool-booking .sendCode .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 100px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 80px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 80px;
}
.tool-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
.element-col-push-8 {
  left: 33.33333333%;
}
.element-col-span-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
/* el-select 样式 */
.tool-booking .el-input__inner {
  /* border: none; 
    border-color: transparent ;
    
    color:#000;
    font-weight: 700; */
  background: #f8f8f8;
  border: none;
  width: 180px !important;
}
.el-select-dropdown__item {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.tool-booking .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.tool-booking.el-input {
  display: inline !important;
}
.tool-booking .el-input input {
  display: block;
}
.tool-booking-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}
.tool-booking .el-textarea__inner {
  background: #f8f8f8;
  width: 490px;
  border: none;
  min-height: 100px !important;
}

.tool-booking .inner-textarea {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 60px;
}

.tool-button-primary button {
  color: #fff;
  font-weight: 700;
}
.tool-button button {
  outline: none;
  background: none;
  border: none;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
#qrCode {
  /* margin-top: 30px; */
  width: 200px;
  height: 200px;
}
</style>
<style scoped>
/* 闪烁动画 */
@keyframes flashDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/

  0% {
    background: #359ff8dd; /*开始为原始大小*/
  }
  10% {
    background: #359ff8ee; /*开始为原始大小*/
  }

  25% {
    background: #359ff8ff;
  }
  40% {
    background: #fdd118;
    color: #222;
  }
  50% {
    background: #fdd118;
    color: #222;
  }
  60% {
    background: #fdd118;
    color: #222;
  }
  75% {
    background: #359ff8ff;
  }
  90% {
    background: #359ff8ee; /*开始为原始大小*/
  }
  100% {
    background: #359ff8dd;
  }
}
.contact-item-flashing {
  -webkit-animation-name: flashDraw; /*关键帧名称*/

  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/

  -webkit-animation-iteration-count: infinite; /*动画播放的次数*/

  -webkit-animation-duration: 2s; /*动画所花费的时间*/
}
.online {
  position: absolute;

  top:-200px;
  left:-500px;
  background: #f00;
  width: 400px;
  height: 400px;
  /* top: -300px;
  left: -1400px; */
}
.tool-booking-order img{
  width: 600px;
}

.qrcode-show-background{
    position: fixed;
    right: 70px;
    /* bottom: 90px; */
    bottom: 162px;
    border-radius: 16px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
    width: 205px;
    height: 246px;
    background: #fff;
    background-size: cover;
    overflow: hidden;
    z-index: 1999;
}
/* .qrcode-show-background img{
    width: 200px;
    height: 308px;
    
} */
.background-contact{
    position: fixed;
    right: 70px;
    bottom: 202px;
    border-radius: 16px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
    width: 256px;
    height: 308px;
    background: #fff;
    overflow: hidden;
    z-index: 1999;
}
.background-contact span{
    display: block;
    font-size: 18px;
    color: #222;
    text-align: center;
    margin-top: 34px;
    font-weight: 700;
    position: absolute;
    width: 100%;
    bottom: 100px;
}
.background-contact p{
    font-size: 12px;
    color: #999;
    text-align: center;
    margin-top: 6px;
    width: 100%;
    position: absolute;
    bottom: 70px;
}
.background-contact .inline-contact{
    position: absolute;
    background: #f96938;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    bottom: 20px;
    width: 110px;
    left: 81px;
    height: 36px;
    line-height: 36px;
    cursor: pointer;
}
.background-contact .close-button, .qrcode-show-background .close-button{
  position: absolute;
  top: 5px;
  right: 15px;
  color: #fff;
  cursor: pointer;
}
.qrcode-show{
  /* height: 400px; */
}
.qrcode-show >>> .el-dialog__title{
  display: inline-block;
  margin-top: 40px;
  /* width: 250px; */
  text-align: center;
}
.qrcode-show >>> .el-dialog__body{
  padding-top:0px;
}
.qrcode-show >>> .el-dialog__body img{
  margin-top:0px;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/quickContact.vue